import { RJLog } from "../../library/ts/node/log/RJLog";
import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { DateFormater } from "../text/DateFormater";
import { DateFormatter } from "./DateFormatter";
import { DateHelper } from "./DateHelper";
import { DateMath } from "./DateMath";
import { DateParser } from "./DateParser";
import { DateRange } from "./DateRange";

export enum DateRepeatType
{
  monthly_at_date,
  monthly_at_weekday,
  weekly,
  not,
  date,
  range
}

export class DateRepeatEntry
{
  type:DateRepeatType;
  value:string;

  getDates( range:DateRange ):Date[]
  {
    RJLog.log( range );
    switch ( this.type )
    {
      case DateRepeatType.monthly_at_date:
      {  
        return this._getMonthlyAtDate( range );
      }

      case DateRepeatType.monthly_at_weekday:  
      {
        return this._getMonthlyAtWeekDay( range );
      }

      case DateRepeatType.weekly:  
      {
        return this._getWeekly( range );
      }

      case DateRepeatType.date:  
      case DateRepeatType.not:
      {
        return this._getDate( range );
      }

    }

    return null;
  }

  getRange()
  {
    if ( DateRepeatType.range != this.type )
    {
      return null;
    }

    return DateParser.parseRange( this.value );
  }

  _getWeekly( range:DateRange ):Date[]
  {
    let dates:Date[] = [];

    let weekdayIndex = DateParser.getWeekDayIndex( this.value );

    range.iterateDays( d => 
      {
        if ( weekdayIndex == d.getDay() )
        {
          dates.push( new Date( d ) );
        }
      }
    );

    return dates;
  }


  _getMonthlyAtWeekDay ( range:DateRange ):Date[]
  {
    let regex = /(^\d)\.(.+)?\s*/;
    let dates:Date[] = [];

    let result = regex.exec( this.value );

    let weekIndex = parseInt( result[ 1 ] ) ;
    
    let weekdayIndex = DateParser.getWeekDayIndex( result[ 2 ] );

    console.log( "Searching weekDayIndex:", result[ 2 ], ">>", weekdayIndex, " at weekIndex", weekIndex );

    range.iterateDays( d => 
      {
        if ( weekdayIndex !== d.getDay() )
        {
          return;
        }

        let weekOffset = Math.ceil( d.getDate() / 7 );

        if ( weekOffset !== weekIndex )
        {
          return;
        }       
        
        dates.push( new Date( d ) );

        console.log( "Adding:", "date:", DateFormatter.toShortInternational( d ), "dayIndex:", d.getDay(),"week", weekOffset );
        
      }
    );


    return dates;
  }

  _getMonthlyAtDate( range:DateRange ):Date[]
  {
    let dates:Date[] = [];

    let day = parseInt( this.value );

    let currentDate = new Date( range.start );
    
    if ( currentDate.getDate() <= day )
    {
      currentDate.setDate( day );
    }

    while ( DateMath.isBeforeOrEquals( currentDate, range.end ) )
    {
      dates.push( currentDate );

      currentDate = DateMath.nextMonth( currentDate );
    }

    return dates;
  }

  

  _getDate( range:DateRange ):Date[]
  {
    console.log( "parsing value:", this.value );
    let parsed = DateRepeat.simpleDateRegex.exec( this.value );

    let day   = parseInt( parsed[ 1 ] );
    let month = parseInt( parsed[ 2 ] );
    let year  = parseInt( parsed[ 3 ] );
    
    if ( year < 30 )
    {
      year += 2000;
    }
    else
    {
      year += 1900;
    }

    let date = DateHelper.createYMD( year, month, day );

    if ( range.contains( date ) )
    {
      return [ date ];
    } 
    
    return [];
  }
}

export class DateRepeat
{
  static readonly test = "monthly_at_date:1,monthly_at_weekday:1.mon,weekly:mon,not:21st-23rd aug";
  static readonly entryRegex = /^(\w+)\s*\:\s*((?:\w|\s|\d|\.)+)$/;

  static get attribute(){ return new ElementAttribute( "date-repeat" ); }

  static get dateRange(){ return new ElementAttribute( "date-range" ); }

  static readonly simpleDateRegex = /^(\d\d?)\.(\d\d?)\.(\d\d)$/;

  static isRepeatType( value:string )
  {
    return /month|week|not|range/.test( value );
  }

  static parseEntries( text:string )
  {
    return text.split( "," ).map( s => DateRepeat.parseEntry( s.trim() ) );
  }

  static parseEntry( text:string )
  {
    if ( /^range:/.test( text ) )
    {
      let entry = new DateRepeatEntry();
      entry.value = text.replace( /^range:/, "");
      entry.type = DateRepeatType.range;
    }

    if ( DateRepeat.simpleDateRegex.test( text ) )
    {
      let entry = new DateRepeatEntry();
      entry.type = DateRepeatType.date;
      entry.value = text;
      return entry;
    }

    let parsed = DateRepeat.entryRegex.exec( text );

   
    RJLog.log( "Parsing:", text, ">>", parsed );

    let type  = parsed[ 1 ].toLowerCase();
    let value = parsed[ 2 ];

    

    let entry = new DateRepeatEntry();
    entry.type = DateRepeatType[ type as keyof typeof DateRepeatType ];
    entry.value = value;

    return entry;
  }
  

  static getDatesOf( text:string, dateRange:DateRange = null ):Date[]
  {
    let dates:Date[] = [];

    let entries = DateRepeat.parseEntries( text );

    if ( DateRepeatType.range == entries[ 0 ].type )
    {
      let range = entries[ 0 ].getRange();
      dateRange = dateRange == null ?  range : dateRange.getOverlap( range );
      entries.shift();
    }

    if ( ! dateRange )
    {
      console.error( "No date range given" );
      return null;
    }

    //console.log( entries );

    var removals:Date[] = [];

    entries.forEach(
      ( e )=>
      {
        let eDates = e.getDates( dateRange );
        
        RJLog.log( "entry", e, ">>", eDates );

        if ( e.type === DateRepeatType.not )
        {
          removals = removals.concat( eDates );
        }
        else
        { 
          dates = dates.concat( eDates );
        }
      }
    )

    dates = dates.filter(
      ( d ) =>
      {
        let isRemoved = removals.find(
          ( removalDate )=>
          {
            return DateMath.isOnSameDay( d, removalDate );
          }
        )

        return ! isRemoved;
      }
    );

    RJLog.log( "dates unsorted:", dates );

    DateMath.sort( dates );

    return dates;
  }
}